export default __webpack_public_path__ + "static/media/btn-zeroback-stop-at_de@2x.7dc8254b.png";